{
  "page_Helseregistre_NavigateBackLinkTitle": "til Helseregistre",
  "page_Samvalg_NavigateBackLinkTitle": "Samval",
  "page_Samvalg_NavigateBackLinkURL": "{HelsenorgeUrl}/samvalg",
  "page_VelgBehandlingssted_NavigateBackLinkTitle": "Vel behandlingsstad",
  "page_Behandlinger_NavigateBackLinkTitle": "Behandlingar"
}
